export const tag = {
  colorScheme: {
    light: {
      primary: {
        color: '{inverse.text.color}',
      },
      secondary: {
        color: '{text.color}',
      },
      info: {
        background: 'rgba(58, 243, 200, 0.14)',
        color: '#45bfa2',
      },
      // warn: {
      //   background: 'var(--p-severity-color-warning)',
      // },

      // background: '#f59e0b',
      // borderColor: '#f59e0b',
      // hoverBackground: '#f59e0b',
      // hoverColor: '#ffffff',
      // hoverBorderColor: '#f59e0b',
    },
    dark: {
      // background: '#f59e0b',
      primary: {
        color: '{text.color}',
      },
      secondary: {
        color: '{text.color}',
      },
      info: {
        background: 'rgba(58, 243, 200, 0.14)',
        color: '#45bfa2',
      },
      // warn: {
      //   background: 'var(--p-severity-color-warning)',
      // },
      // borderColor: '#f59e0b',
      // hoverBackground: '#f59e0b',
      // hoverColor: '#ffffff',
      // hoverBorderColor: '#f59e0b',
    },
  },
  extend: {
    accent: {
      color: '#f59e0b',
      inverseColor: '#ffffff',
      borderColor: '#f59e0b',
    },
  },
  css: ({ dt }: { dt: (key: string) => string }) => `

    `,
};
